const loginInputFocus = () => {
    $('#inputEmail').focus();
};

export {
    loginInputFocus
}
